import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Button, Col } from "reactstrap";
import BreadCrumb from "../../Common/BreadCrumb";
import { ToastContainer, toast } from "react-toastify";
import { MaterialReactTable } from "material-react-table";
import { Loader } from "../../Utils/Loader";
import { attributeColoumns } from "./constants/AttributeColumns";
import { useNavigate } from "react-router-dom";
import { getAllAttribute } from "../../../slices/services/addservice/provisionalattribute/thunk";
import { useDispatch, useSelector } from "react-redux";
import { setEditSuccessMessage, setSuccessMessage } from "../../../slices/toastMessage/action";
import CommonModal from "../../Utils/CommonModal";
import { deleteAttribute } from "../../../slices/attribute/deleteattribute/thunk";
import { useColumnSettings } from "../../Utils/useColumnSettings";
import { getView } from "../../../slices/View/thunk";
import { bulkDelete } from "../../../slices/BulkDelete/thunk";
import { MenuItem } from "@mui/material";
import { navigateToAddAttribute } from "./constants/AttributeJsonObj";
import { handleExportData } from "../../Utils/ExportToCsv";
import { AttributeModal } from "./AttributeModal";
import { hasPermission } from "../../Utils/UtilityFunctions";

export default function AttributeList() {
    const [loading, setLoading] = useState()
    const [messageForPopUp, setMessageForPopUp] = useState('')
    const [modal, setModal] = useState(false);
    const [attributeName, setAttributeName] = useState()
    const [modalForBulkDelete, setModalForBulkDelete] = useState(false)
    const [selectedRowsForBulkDelete, setSelectedRowsForBulkDelete] = useState()
    const [attributeArray, setAttributeArray] = useState([]);
    const [selectAllAttributes, setSelectAllAttributes] = useState(false)
    const [selectedAttribute, setSelectedAttribute] = useState([])
    const checkboxRef = useRef(null);
    const [modalOpen, setModalOpen] = useState(false)
    const [attributeModalOpen, setAttributeModalOpen] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [editAttribute, setEditAttribute] = useState(null)

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const isMobile = window.innerWidth <= 768;

    const toggleModal = (id, singleOrMulti) => {
        if (singleOrMulti === "single") {
            setAttributeName(id)
            setModal(!modal);
        }
        else {
            setSelectedRowsForBulkDelete(id)
            setModalForBulkDelete(!modalForBulkDelete)
        }
        document.body.style.overflow = 'auto'
    };

    useEffect(() => {
        dispatch(getAllAttribute(setLoading));
        dispatch(getView(setLoading));
    }, [dispatch]);
    const attributes = useSelector((state) => state.Provisional.provisional);
    const showSuccessMessage = useSelector((state) => state.SuccessToast.showSuccessMessage)
    const showEditSuccessMessage = useSelector((state) => state.SuccessToast.showEditSuccessMessage);
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const attributePermission = hasPermission(permissionsMap, "pricing", "attribute")
    const attributeInventoryPermission = hasPermission(permissionsMap, "configuration", "attribute")
    const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")

    useEffect(() => {
        if (showSuccessMessage) {
            toast.success(`Attribute Created Successfully`);
            dispatch(setSuccessMessage(false))
        }
        if (showEditSuccessMessage) {
            toast.success(`Attribute Updated Successfully`);
            dispatch(setEditSuccessMessage(false));
        }
    }, [showSuccessMessage, showEditSuccessMessage, dispatch])

    useEffect(() => {
        if (checkboxRef.current) {
            checkboxRef.current.indeterminate = selectedAttribute.length > 0 && selectedAttribute.length < attributes.length;
        }
        setSelectAllAttributes(selectedAttribute?.length > 0 && attributes?.length > 0 && selectedAttribute?.length === attributes?.length);
    }, [selectedAttribute, attributes.length, setSelectAllAttributes]);

    const columns = attributeColoumns(selectAllAttributes, setSelectAllAttributes, attributes, setSelectedAttribute, selectedAttribute, checkboxRef, isMobile, modalOpen)

    const {
        CustomViewModal,
        settingsModalOpen,
        viewColumns,
        toggleSettingsModal,
        SettingsSidebar
    } = useColumnSettings('attribute', columns);

    useEffect(() => {
        setModalOpen(settingsModalOpen)
    }, [settingsModalOpen])

    return (
        <React.Fragment>
            <div id='csms' className='page-content bg-white mb-0'>
                <Container fluid>
                    <BreadCrumb title="Attributes" pageTitle="Attributes" />
                    <div className="d-flex flex-sm-row flex-column w-100 justify-content-between align-items-lg-center gap-2 mb-1 mt-0">
                        <div className="d-flex flex-row gap-2">
                            <h5 className="rv-page-title p-2">Attributes List</h5>
                        </div>
                        <div className="d-flex align-items-center">
                            {selectedAttribute?.length ?
                                <Button
                                    className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                    color="secondary"
                                    onClick={() => {
                                        const names = selectedAttribute.map(row => row.name);
                                        let uniqueAttributes = Array.from(new Set(names))
                                        setAttributeArray(uniqueAttributes);
                                        setMessageForPopUp(`Are you sure you want to delete the selected items?`)
                                        toggleModal(selectedAttribute, "multi")
                                    }}
                                >
                                    <i className="ri-delete-bin-6-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                    <span className="px-2 ps-2 ms-2 me-1">Delete</span>
                                </Button> : null}
                            {(attributePermission?.has("export") || attributeInventoryPermission?.has("export")) &&
                                <Button
                                    color="secondary"
                                    className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                    onClick={() => {
                                        handleExportData(attributes)
                                    }}
                                >
                                    <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                    <span className="px-2 ps-3 ms-2 me-1">Export</span>
                                </Button>}
                            {(attributePermission?.has("create") || attributeInventoryPermission?.has("create")) &&

                                <Button
                                    color="secondary"
                                    className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                    onClick={() => setAttributeModalOpen(true)}
                                >
                                    <i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>
                                    <span className="ps-2 ms-2 me-1">Add Attributes</span>
                                </Button>
                            }
                            {(viewPermission?.has("view") || attributeInventoryPermission?.has("view")) &&
                                <i className="ri-settings-2-line fs-4" onClick={toggleSettingsModal}></i>}
                        </div>
                        {CustomViewModal()}
                    </div>
                    <ToastContainer position='top-center' />
                    <Row className="d-flex align-items-sm-start">
                        <Col lg={12}>
                            <div className="container-fluid px-0">
                                <div className="disable-margin-card table-responsive table-customer border w-100"
                                style={{ borderRadius: "4px" }}>
                                    {loading && (<Loader />)}
                                    {attributes ? <MaterialReactTable
                                        enableTopToolbar={false}
                                        icons={{ DragHandleIcon: () => <i className="ri-drag-move-fill" />, }}
                                        positionToolbarAlertBanner='none'
                                        muiSelectCheckboxProps={{
                                            color: 'warning'
                                        }}
                                        muiSelectAllCheckboxProps={{
                                            color: 'warning'
                                        }}
                                        displayColumnDefOptions={{
                                            'mrt-row-actions': {
                                                header: '',
                                                enableHiding: true,
                                                size: 36,
                                                grow: true,
                                                muiTableBodyCellProps: {
                                                    sx: {
                                                        fontFamily: "Inter,sans-serif",
                                                        maxWidth:"60px"
                                                    }
                                                },
                                                muiTableHeadCellProps: {
                                                    sx: {
                                                        fontFamily: "Inter,sans-serif",
                                                        maxWidth:"60px"
                                                    }
                                                }
                                            },
                                        }}
                                        initialState={{
                                            columnOrder: [
                                                'checkbox',
                                                'mrt-row-actions',
                                                'Name',
                                                'Type',
                                                'Value Type'
                                            ]
                                        }}
                                        columns={columns.filter((column) => viewColumns?.includes(column.accessorKey || column.header))}
                                        data={attributes}
                                        enableRowActions={true}
                                        enableColumnOrdering
                                        enableSorting={true}
                                        enableColumnDragging={false}
                                        enableDensityToggle={false}
                                        enableColumnFilters={true}
                                        enableColumnActions={true}
                                        defaultColumn={{
                                            // minSize: 10,
                                            maxSize: 9001,
                                            size: 260,
                                            muiTableBodyCellProps: {
                                                sx: {
                                                    fontFamily: "Inter,sans-serif"
                                                }
                                            },
                                            muiTableHeadCellProps: {
                                                sx: {
                                                    fontFamily: "Inter,sans-serif"
                                                }
                                            }
                                        }}
                                        layoutMode='grid'
                                        renderRowActionMenuItems={({ closeMenu, row }) =>
                                            [
                                                attributePermission?.has("update") || attributeInventoryPermission?.has("update") ? <MenuItem className="row-options pb-3" data-testid="update" key="update" onClick={() => {
                                                    setIsEdit(true)
                                                    setEditAttribute(row.original.name)
                                                    setAttributeModalOpen(true);
                                                    closeMenu()
                                                }} >
                                                    <i className='ri-edit-box-line me-2' /> Edit </MenuItem> : null,
                                                attributePermission?.has("delete") || attributeInventoryPermission?.has("delete") ? <MenuItem className="row-options pb-3" key="delete" onClick={() => { setMessageForPopUp(`Are you sure you want to Delete this Attribute "${row.original.name}"?`), toggleModal(row, "single"), closeMenu() }}>
                                                    <i className="ri ri-delete-bin-5-line me-2" />{" "}
                                                    Delete
                                                </MenuItem> : null,
                                            ]
                                        } /> : null}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div>
                <CommonModal open={modalForBulkDelete ? modalForBulkDelete : modal} toggle={() => { if (modal) { toggleModal(attributeName, "single") } else { toggleModal(selectedRowsForBulkDelete, "multi") } }} buttonText={"Yes, Delete It"} messageForPopUp={messageForPopUp} modalHeader="Delete Attribute" modalAction={() => {
                    if (modal) {
                        dispatch(deleteAttribute(attributeName.original.name, setLoading))
                        toggleModal(attributeName, "single")
                    }
                    else {
                        let jsonObj = { ids: attributeArray, type: "Attribute" }
                        dispatch(bulkDelete(jsonObj, setLoading))
                        setSelectAllAttributes(false)
                        setSelectedAttribute([])
                        toggleModal(selectedRowsForBulkDelete, "multi")
                    }
                }} />
                <AttributeModal attributeModalOpen={attributeModalOpen} setAttributeModalOpen={setAttributeModalOpen} isEdit={isEdit} setIsEdit={setIsEdit} editAttribute={editAttribute} setEditAttribute={setEditAttribute} />
            </div>
        </React.Fragment>
    )
}